import { logos } from 'common'
import { css } from 'styled-components'

export const wsbVars = css`
  :root {
    /********************
    // NEW theme colors //
    *********************/
    --site-primary-color: #4511a1;
    --primary-text-color: rgba(255, 255, 255, 1);
    --site-background: linear-gradient(45deg, #19063a, #1b073f, #1c0843, #1e0848, #21094d, #230951, #250956, #27095b);
    --primary-button-background: linear-gradient(
      0deg,
      #4511a1,
      #4711a6,
      #4a12ac,
      #4c12b1,
      #4e13b7,
      #5013bc,
      #5314c1,
      #5514c7
    );
    --primary-button-hover-background: #5514c7;
    --primary-button-border: #4c12b1;
    --primary-active: #4511a1;

    --side-panel-background: hsla(0, 0%, 100%, 0.1);

    //details
    --summary-color: #ffffff;
    --summary-background-color: hsla(0, 0%, 100%, 0.1);
    --summary-background-color-hover: hsl(213, 19%, 5%);
    --summary-bg-color-open: hsla(0, 0%, 100%, 0.1);
    --summary-bg-color-close: linear-gradient(
      180deg,
      #2c2d35,
      #2b2c34,
      #2a2b33,
      #292a32,
      #282930,
      #27282f,
      #26272e,
      #25262d
    );
    --summary-bg-color-hover: hsl(213, 19%, 5%);

    --input-background: hsla(0, 0%, 100%, 0.1);
    --input-border: rgba(85, 20, 199, 0.5);

    --toggle-background: hsla(0, 0%, 100%, 0.2);
    --toggle-active-background: #4511a1;

    --dropdown-header-background: hsla(0, 0%, 100%, 0.2);
    --overlay-pad-background: hsla(0, 0%, 90%, 0.1);
    --chat-message-pad-background: hsla(0, 0%, 100%, 0.07);
    --box-shadow-color: rgba(0, 0, 0, 0.4);
    --modal-pad-background: hsla(0, 0%, 100%, 0.05);

    // toggle
    --toggle-switch-background: #ffffff;
    --toggle-switch-border: none;

    --toggle-body-border: 1px solid transparent;
    --toggle-body-background: hsla(0, 0%, 100%, 0.2);

    --toggle-active-background: #4511a1;
    --toggle-active-border: #4511a1;

    //Tabs
    --tab-text-color: rgba(255, 255, 255, 0.35);
    --tab-section-background: hsla(214, 18%, 25%, 0.3);

    --tab-hover-background: rgba(255, 255, 255, 0.05);
    --tab-hover-text-color: #b3cbff;
    --tab-hover-text-shadow: rgba(42, 109, 255, 1);

    //Left panel
    --panel-profile-background: #4b3a6d;

    //Bidding Table
    --bidding-table-background: hsl(261, 60%, 21%);
    --bidding-table-header-background: hsl(261, 60%, 21%);
    --bidding-table-tab-selected-background: hsla(0, 0%, 100%, 0.1);
    --bidding-table-tab-selected-text-shadow: 0 0 10px hsl(262, 82%, 35%);
    --bidding-table-tab-selected-text-color: hsl(0, 0%, 100%);
    --bidding-table-cell-border: hsla(0, 0%, 100%, 0.1);

    //Tabs bar
    --tab-bar-border: hsla(224, 2%, 54%, 0.4);
    --tab-bar-color: hsl(224, 2%, 54%);
    --tab-bar-background: hsla(0, 0%, 0%, 0.1);
    --tab-bar-color: hsla(0, 0%, 100%, 0.5);
    --tab-bar-active-border: hsla(262, 82%, 44%, 0.7);
    --tab-bar-active-background: hsl(262, 82%, 44%);
    --tab-bar-active-color: hsl(0, 0%, 100%);

    //Share card
    --share-card-background: #21094d;

    /*********************************
    // LOGOS and other images files //
    ********************************/
    --main-logo: url(${logos.wsb_logo_neon});
    --main-logo-margin-top: 0px;
    --lvg-graph-container-margin-top: 75px;
  }
`
